import CustomFormGroup from "components/Atoms/CustomFormGroup"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import { SI_UNITS } from "graphql/selector.queries.gql"
import React from "react"

type DimensionsInputProps = { big?: boolean }
const DimensionsInput = ({ big = true }: DimensionsInputProps) => {
  return (
    <CustomFormGroup
      big={big}
      helperText="Length (L) x Breadth (B) x Height (H)"
      className="vt-dimensions-input"
      label="Dimensions"
    >
      <div className="inputs">
        <StringInput
          className="mr-2"
          big={big}
          type="number"
          path="dimensions.0"
          placeholder="L"
        />
        <StringInput
          className="mr-2"
          big={big}
          type="number"
          path="dimensions.1"
          placeholder="B"
        />
        <StringInput
          className="mr-2"
          big={big}
          type="number"
          path="dimensions.2"
          placeholder="H"
        />
        <DynamicSelector big={big} query={SI_UNITS} path="dimensionUnit" />
      </div>
    </CustomFormGroup>
  )
}

export default DimensionsInput
